import { PulseLoader } from 'react-spinners';
import Header from './HeaderMetedBase';

const Loading = () => {
    return (
        <div>
             <Header ready={false} />
             <div className='flex justify-center py-40'>
             <p className='sr-only'>Loading...</p>
                <PulseLoader color="#1a658f" size={20} />
             </div>
        </div>)
}

export default Loading;